import i18n from '../../locales/index'
import { genBasicStore } from '../vuex'
import axios from 'axios';

const store = genBasicStore('enough_consume_discount')

store.actions.toggleRun = function ({ commit }, id) {
  return axios.post(`/enough_consume_discounts/${id}/run`);
}

export default store;
